$(function(){
　$(window).scroll(function (){
    $('.effect-fade').each(function(){
      let elemPos = $(this).offset().top;
      let scroll = $(window).scrollTop();
      let windowHeight = $(window).height();

      if (scroll > elemPos - windowHeight){
        $(this).addClass('effect-scroll');
      }
    });
　});

  if (window.innerWidth > 750) {
    $('.effect-fade-pc').each(function(){
      let elemPos = $(this).offset().top;
      let scroll = $(window).scrollTop();
      let windowHeight = $(window).height();

      if (scroll > elemPos - windowHeight){
        $(this).addClass('effect-scroll');
      }
    });
  }
});